module.exports = __webpack_public_path__ + "media/src/images/devpost-icon-rgb30px-cf33601e5c3b0e238dfead218b072884.png";